import { render } from "./ResidentsSearchResult.vue?vue&type=template&id=df4296e6&scoped=true"
import script from "./ResidentsSearchResult.vue?vue&type=script&lang=js"
export * from "./ResidentsSearchResult.vue?vue&type=script&lang=js"

import "./ResidentsSearchResult.vue?vue&type=style&index=0&id=df4296e6&scoped=true&lang=css"

import exportComponent from "/Users/akiowatanabe/work_space/secure_link/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4296e6"]])

export default __exports__